import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import {
  BulletinApiRequest,
  UpdateBulletinRequest,
  DeleteBulletinRequest,
} from '@/data/payload/api/BulletinRequest'
import { BulletinPresenter } from '@/app/ui/presenters/BulletinPresenter'
import { Bulletin } from '@/domain/entities/Bulletin'
import router from '@/router'
import Vue from 'vue'
import { AuthModule } from './auth'

export interface BulletinState {
  bulletinData: Bulletin
  isLoading: boolean
  paginationParam: Object
}

@Module({ namespaced: true, dynamic: true, store, name: 'bulletin' })
class Bulletins extends VuexModule implements BulletinState {
  public bulletinData = new Bulletin(true, '')
  public Pages = 0
  public Limit = 10
  public isLoading = true
  public paginationParam = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'CreateDate',
      type: 'desc',
    },
    search: '',
  }

  @Action
  public async getBulletinData() {
    this.setLoading(true)
    const presenter = await container.resolve(BulletinPresenter)
    presenter
      .loadBulletin(this.paginationParam)
      .then((res: Bulletin) => {
        //  console.log('bulletin =====>', res)
        this.setpages(this.paginationParam.paging.page)
        this.setlimit(this.paginationParam.paging.limit)
        this.setLoading(false)
        this.setBulletinData(res)
      })
      .catch((error) => {
        this.setLoading(false)
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        router.push('/404/index')
      })
  }

  @Action
  public async postBulletin(params: {
    title: string
    fileCode: string
    ownerId: string
    imageThumbnailId: number
    isActive: boolean
    isRecommended: boolean
    fileName: string
    fileByte: string
    fileUpload: any
    expireddate: string
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(BulletinPresenter)
    presenter
      .postBulletin(
        new BulletinApiRequest(
          params.title,
          params.fileCode,
          params.imageThumbnailId,
          params.isActive,
          params.isRecommended,
          params.fileName,
          params.fileByte,
          params.fileUpload,
          params.expireddate,
          params.ownerId
        )
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Bulletin',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getBulletinData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Action
  public async updateBulletin(params: {
    id: number
    fileCode: string
    title: string
    imageThumbnailId: number
    isActive: boolean
    isRecommended: boolean
    fileName: string
    fileByte: string
    fileUpload: any
    expireddate: string
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(BulletinPresenter)
    presenter
      .updateBulletin(
        new UpdateBulletinRequest(
          params.title,
          params.fileCode,
          params.imageThumbnailId,
          params.isActive,
          params.isRecommended,
          params.fileName,
          params.fileByte,
          params.fileUpload,
          params.expireddate
        ),
        params.id
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Bulletin',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getBulletinData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Action
  public async deleteBulletin(params: { ids: any }) {
    this.setLoading(true)
    const presenter = await container.resolve(BulletinPresenter)
    presenter
      .deleteBulletin(new DeleteBulletinRequest(params.ids))
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Bulletin',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getBulletinData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Mutation
  private setBulletinData(bulletin: Bulletin) {
    this.bulletinData = bulletin
  }

  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }
  @Mutation
  private setpages(pages: number) {
    this.Pages = pages
  }
  @Mutation
  private setlimit(limit: number) {
    this.Limit = limit
  }
}

export const BulletinModule = getModule(Bulletins)
